module.exports = __webpack_public_path__ + "media/marketing.2da2e2b2.mp4";